<template>
  <div>
    <Wrapper>
      <div class="mb-10 text-left">
        <h2 class="text-xl"><b>Información de la dirección</b></h2>
        <p class="text-gray-500">
          Edite la información de la dirección y las entidades asociadas
        </p>
      </div>
      <form
        @submit.prevent="onSubmit"
        class="mx-auto max-w-2xl"
        v-if="!loading"
      >
        <div class="w-full grid grid-cols-1 lg:grid-cols-2 gap-2">
          <BaseInput
            type="text"
            label="Nombre de la dirección"
            placeholder="Ej: Dirección de conductas"
            v-model="form.name"
          />
          <BaseMultiSelect
            :valuesSelected="void_array"
            title="Asociar entidades"
            placeholder="Seleccione el código"
            :data="optionsCompanies"
            label="name"
            @notify-objects="setMultiSelect($event)"
          />
        </div>
        <div class="w-full grid grid-cols-1 lg:grid-cols-1 gap-2">
          <BaseTextarea
            ref="describe"
            id="describe"
            label="Descripción de la dirección"
            placeholder="Descripción"
            v-model="form.description"
            maxlength="1000"
          />
        </div>

        <div v-if="feedback">
          <p class="my-2 text-xs text-center text-red-500">{{ feedback }}</p>
        </div>
        <div
          class="w-full lg:max-w-sm mt-8 ml-auto flex flex-col lg:flex-row lg:justify-end gap-5"
        >
          <a-button
            type="danger"
            @click="$router.go(-1)"
            ghost
            shape="round"
            :block="true"
            :loading="loading2"
          >
            <span class="mx-2">CANCELAR</span>
          </a-button>
          <a-button
            type="primary"
            html-type="submit"
            shape="round"
            :block="true"
            :loading="loading2"
          >
            <span class="mx-2">ACTUALIZAR</span>
          </a-button>
        </div>
      </form>
      <div v-if="loading" class="flex justify-center items-center mt-32">
        <a-spin>
          <a-icon
            slot="indicator"
            type="loading"
            style="font-size: 64px"
            spin
          />
        </a-spin>
      </div>
    </Wrapper>
  </div>
</template>

<script>
import Wrapper from "../../UI/Wrapper";
export default {
  components: { Wrapper },
  data() {
    return {
      value: 2,
      loading: false,
      loading2: false,
      feedback: null,
      optionsCompanies: [],
      void_array: [],
      idDirection: "",
      form: {
        id: "",
        name: "",
        entities: [],
        description: "",
        is_admin: false,
      },
    };
  },
  mounted() {
    this.loading = true;
    this.init();
  },
  methods: {
    init() {
      const { id } = this.$route.query;
      this.idDirection = id;
      this.loadCompanies();
      if (this.idDirection) {
        this.getDirectionData();
      } else {
        this.$router.go(-1);
      }
    },
    loadCompanies() {
      this.optionsCompanies = this.$store.state?.form.optionsCompanies.filter(
        (company) =>
          company.direction == null || company.direction == this.idDirection
      );
    },
    async getDirectionData() {
      this.loading = true;
      let { error, data } = await this.$api.getDirection(this.idDirection);
      this.loading = false;
      if (error) {
        this.showToast("Ocurrió un error al cargar los datos de la dirección.");
      } else if (data) {
        this.form.name = data.name;
        this.form.description = data.description;
        this.form.entities = data.entities.map((item) => item.id);
        this.form.is_admin = data.admin ? [1] : [];
        this.void_array = this.form.entities;
      }
    },
    async onSubmit() {
      if (this.checkForm()) {
        const { id } = this.$route.query;
        this.form.id = id;
        this.loading2 = true;
        const form = { ...this.form };
        if (form.entities.length > 0) {
          form.is_admin = false;
        } else {
          form.is_admin = true;
        }
        let { error, data } = await this.$api.updateDirection(id, form);

        this.loading2 = false;
        if (error) this.showToast("error", "Error actualizando la dirección.");

        if (data) {
          if (data.code === 401) {
            this.showToast("error", data.error);
          } else if (data.code === 402) {
            this.showToast("error", data.error);
          } else if (data.code === 403) {
            this.showToast("error", data.error);
          } else if (data.code === 404) {
            this.showToast("error", data.error);
          } else {
            this.$store.dispatch("form/loadListOptions", {
              endpoint: "direction/",
              name: "optionsDirections",
            });
            this.$store.dispatch("form/loadListOptions", {
              endpoint: "company/",
              name: "optionsCompanies",
            });
            this.showToast("success", "Dirección actualizada correctamente.");
            this.$router.go(-1);
          }
        }
      }
    },
    setMultiSelect(ev) {
      this.form.entities = ev.map((item) => item.id);
    },
    checkForm() {
      this.feedback = null;

      if (this.$validator.isEmpty(this.form.name)) {
        this.feedback = "Es necesario un nombre para la dirección";
        return false;
      }
      return true;
    },
    showToast(result = "info", msg) {
      this.$notification[result]({
        message: "Resultado",
        description: msg,
        onClick: () => {},
      });
    },
  },
  watch: {
    "$store.state.form.optionsCompanies": async function () {
      this.optionsCompanies =
        await this.$store.state.form.optionsCompanies.filter(
          (company) =>
            company.direction == null || company.direction == this.idDirection
        );
    },
  },
};
</script>

<style></style>
